import { apiRequest } from '@scc/lib'
import type { FreshnessRepository } from '@/data/repositories/types'
import type { FreshnessRecord, DataSource } from '@/modules/freshness/types'

interface ApiFreshnessRow {
  dataSource: string
  updatedAt: string
  status: string
}

const KNOWN_SOURCES: DataSource[] = ['shop-daily', 'video-daily', 'ads-daily']

export function mapFreshnessRow(row: ApiFreshnessRow, clientId: string): FreshnessRecord {
  return {
    clientId,
    dataSource: row.dataSource as DataSource,
    updatedAt: row.updatedAt,
    updatedBy: 'Automated sync',
  }
}

export function createApiFreshnessRepository(): FreshnessRepository {
  return {
    async getFreshness(_orgId: string, clientId: string): Promise<FreshnessRecord[]> {
      const rows = await apiRequest<ApiFreshnessRow[]>('/analytics/data-quality/freshness', {
        headers: { 'X-Store-Id': clientId },
      })
      return rows
        .filter((r) => (KNOWN_SOURCES as string[]).includes(r.dataSource))
        .map((r) => mapFreshnessRow(r, clientId))
    },
    // Freshness is pipeline-driven now; manual "mark refreshed" no longer mutates.
    async recordRefresh(
      _orgId: string,
      clientId: string,
      dataSource: DataSource,
      _actor: string,
    ): Promise<FreshnessRecord> {
      return { clientId, dataSource, updatedAt: new Date().toISOString(), updatedBy: 'Automated sync' }
    },
  }
}
